import "./../styles/Services.css";
import infra from "../assets/images/infra.jpeg";
import transformation from "../assets/images/transformation.jpg";
import device from "../assets/images/device.jpg";
import digital from "../assets/images/digital.jpeg";
import cloud from "../assets/images/cloud.png";
import web from "../assets/images/web.jpg";
import mobileapp from "../assets/images/images.jpeg";
import uiux from "../assets/images/uiux.png";
import { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const Services = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        if (location.hash) {
            const element = document.getElementById(location.hash.substring(1)); // Remove the "#"
            // if (element) {
            //   element.scrollIntoView({ behavior: 'smooth' }); // Smooth scroll
            // }
            if (element) {
                // Calculate position relative to viewport
                const offset = 250; // Adjust if you have a fixed header
                const elementPosition =
                    element.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({
                    top: elementPosition - offset,
                    behavior: "smooth",
                });
            }
        }
    }, [location]);

    const faqData = [
        {
            question: "How long does a website project take?",
            answer: "Depending on complexity, from 4 to 12 weeks.",
        },
        {
            question: "Do you provide support after launch?",
            answer: "Yes, bug fixes, updates, hosting, and monitoring are included.",
        },
        {
            question: "How do you ensure SEO-friendly development?",
            answer: "We optimize URL structures, meta tags, mobile responsiveness, and use schema markup.",
        },
        {
            question: "What technologies do you use?",
            answer: "We work with Laravel, React, Vue, Flutter, React Native, WordPress, and more.",
        },
    ];

    const serviceSections = [
        {
            id: "infra-structure",
            title: "INFRASTRUCTURE",
            desc: "Our depth and breadth in IT infrastructure and Cloud Technologies makes us the preferred partner for many of our recent successful digital transformation.",
            image: infra,
        },
        {
            title: "TRANSFORMATION",
            desc: "Business transformation programs have long focused on productivity.",
            image: transformation,
            items: [
                "Cloud Base Migrations",
                "Technology Migration",
                "Mobile Devices Management",
            ],
        },
        {
            title: "MODERN DEVICE MANAGEMENT",
            desc: "Crafting visually appealing, responsive, and user-friendly websites that reflect your brand.",
            image: device,
        },
        {
            id: "Digital-marketing",
            title: "Digital Marketing",
            desc: "Crafting targeted digital campaigns to boost brand visibility, engagement, and conversions across multiple online platforms.",
            image: digital,
        },
        {
            id: "cloud-host",
            title: "CLOUD HOSTING",
            desc: "We partner with top global cloud providers, delivering integrated AWS Cloud and DevOps solutions, hosted securely on Hostinger.",
            image: cloud,
        },
        {
            id: "web-dev",
            title: "WEB DEVELOPMENT",
            desc: "Developing fast, secure, and scalable websites tailored to your business objectives.",
            image: web,
        },
        {
            id: "mobile-dev",
            title: "MOBILE APP DEVELOPMENT",
            desc: "Building scalable and intuitive mobile apps for both Android and iOS platforms.",
            image: mobileapp,
        },
        {
            id: "ui-ux",
            title: "UI/UX DESIGN",
            desc: "Designing seamless and engaging user experiences with intuitive and modern interfaces.",
            image: uiux,
        },
    ];

    const processSteps = [
        {
            title: "Discovery",
            desc: "We start by understanding your business, goals, and requirements through in-depth consultations.",
        },
        {
            title: "Planning",
            desc: "Our team creates a detailed project plan with timelines, milestones, and deliverables.",
        },
        {
            title: "Design",
            desc: "We design user-centered interfaces and experiences that align with your brand and objectives.",
        },
        {
            title: "Development",
            desc: "Our developers bring the designs to life using the latest technologies and best practices.",
        },
        {
            title: "Testing",
            desc: "Rigorous testing ensures your product is bug-free, secure, and performs optimally.",
        },
        {
            title: "Launch",
            desc: "We handle the deployment process and ensure a smooth transition to the live environment.",
        },
        {
            title: "Support",
            desc: "Our relationship continues with ongoing support, maintenance, and optimization.",
        },
    ];

    const toggleFAQ = (index) => {
        setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
    };
    return (
        <div>
            <section className="software-dev-services">
                <h2 className="software-dev-title">
                    SOFTWARE DEVELOPMENT SERVICES
                </h2>
                {serviceSections.map((section, idx) => (
                    <div
                        className={`dev-section-row ${
                            idx % 2 === 1 ? "reverse" : ""
                        }`}
                        key={section.title}
                        id={section.id}
                    >
                        <div className="dev-section-image">
                            <img src={section.image} alt={section.title} />
                        </div>
                        <div className="dev-section-content">
                            <h3>{section.title}</h3>
                            <p>{section.desc}</p>
                            {section.items && (
                                <ul className="dev-section-list">
                                    {section.items.map((item) => (
                                        <li key={item}>{item}</li>
                                    ))}
                                </ul>
                            )}
                            {section.icons && (
                                <div className="dev-section-icons">
                                    {section.icons.map((icon, i) => (
                                        <span key={i}>{icon}</span>
                                    ))}
                                </div>
                            )}
                            {section.sideCard && (
                                <div className="dev-side-card">
                                    <h4>{section.sideCard.title}</h4>
                                    <p>{section.sideCard.desc}</p>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </section>

            <section className="faq-container">
                <h2 className="faq-title">Frequently Asked Questions</h2>
                <div className="faq-list">
                    {faqData.map((faq, index) => (
                        <div
                            className={`faq-item ${
                                activeIndex === index ? "active" : ""
                            }`}
                            key={index}
                        >
                            <button
                                className="faq-question"
                                onClick={() => toggleFAQ(index)}
                            >
                                {faq.question}
                                <span className="faq-icon">
                                    {activeIndex === index ? "−" : "+"}
                                </span>
                            </button>
                            <div className="faq-answer">{faq.answer}</div>
                        </div>
                    ))}
                </div>
            </section>

            <section className="our-process-section">
                <h2 className="process-title">Our Process</h2>
                <p className="process-subtitle">
                    We follow a structured approach to ensure the success of
                    every project.
                </p>
                <div className="timeline-container">
                    <div className="timeline">
                        {processSteps.map((step, idx) => (
                            <div
                                className={`timeline-row ${
                                    idx % 2 === 0 ? "left" : "right"
                                }`}
                                key={step.title}
                            >
                                <div className="timeline-content">
                                    <div className="timeline-card">
                                        <div className="timeline-icon"></div>
                                        <div className="timeline-title">
                                            {step.title}
                                        </div>
                                        <div className="timeline-desc">
                                            {step.desc}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                        <div className="timeline-vertical-line"></div>
                    </div>
                </div>
            </section>
            <section className="cta-section">
                <h2 className="cta-title">Ready to Start Your Project?</h2>
                <p className="cta-subtitle">
                    Contact us today to discuss how we can help your business
                    grow with our innovative digital solutions.
                </p>
                <button
                    onClick={() => navigate("/contact")}
                    className="cta-btn no-underline"
                >
                    Get In Touch
                </button>
            </section>
        </div>
    );
};

export default Services;
